const HTML_WHITESPACE_ENTITY_RE = /(&nbsp;|&#160;|&#xA0;)/gi;
const ZERO_WIDTH_RE = /[\u200B-\u200D\uFEFF]/g;
const NBSP_RE = /\u00A0/g;

const normalizeWhitespace = (value) => {
  return String(value)
    .replace(NBSP_RE, ' ')
    .replace(ZERO_WIDTH_RE, '')
    .replace(/\s+/g, ' ')
    .trim();
};

export const getDescriptionText = (value) => {
  if (value == null) return '';

  const html = String(value);

  if (typeof DOMParser !== 'undefined') {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return normalizeWhitespace(doc?.body?.textContent || '');
  }

  const withoutEntities = html.replace(HTML_WHITESPACE_ENTITY_RE, ' ');
  const withoutScriptStyle = withoutEntities
    .replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '')
    .replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, '');
  const withLineBreaks = withoutScriptStyle.replace(/<br\s*\/?>/gi, '\n');
  const stripped = withLineBreaks.replace(/<[^>]*>/g, '');
  return normalizeWhitespace(stripped);
};

export const coalesceDescription = (value, fallbackText = 'Optimización sugerida') => {
  const text = getDescriptionText(value);
  if (!text) return fallbackText;
  return String(value).trim();
};

